import { useEffect } from "react";

const BookJavits = () => {
  // keep the noindex so search engines don't index this kiosk page
  useEffect(() => {
    const metaNoIndex = document.createElement("meta");
    metaNoIndex.name = "robots";
    metaNoIndex.content = "noindex, nofollow";
    document.head.appendChild(metaNoIndex);
    return () => {
      document.head.removeChild(metaNoIndex);
    };
  }, []);

  return (
    <div className="fixed inset-0 bg-black">
      <iframe
        src="https://quietcove.wiseingress.com/#/quietcove;uid=a7b592c9-8259-46af-8da3-5983581c6d98;source=iframe"
        className="w-full h-full border-0"
        allow="payment *; clipboard-read; clipboard-write"
        loading="eager"
        referrerPolicy="no-referrer-when-downgrade"
        title="Quiet Corner Booking Kiosk"
      />
    </div>
  );
};

export default BookJavits;

